import React from 'react'
import { Navbar} from '../components'
import PrivacyPolicy from '../components/PrivacyPolicy'

const PolicyPage = () => {
  return (
    <div>
        <Navbar />
        <PrivacyPolicy />
    </div>
  )
}

export default PolicyPage